<template>
  <div>
    <ul>
      <li class="has-text-left is-size-5 columns">
        <p class="column is-1">Q.</p>
        <p class="column is-11">{{QnA.question}}</p>
      </li>
      <li class="has-text-left is-size-6 columns">
        <p class="column is-1">A.</p>
        <p class="column is-11">{{QnA.answer}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default { name: "askedQuestion", props: { QnA: Object } };
</script>

<style lang="scss">
@import "../../assets/scss/only-lms/partials/askedQuestion";
</style>

